import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_PERMISE_RESET = 'POST_PERMISE_RESET';
export const POST_PERMISE_LOADING = 'POST_PERMISE_LOADING';
export const POST_PERMISE_SUCCESS = 'POST_PERMISE_SUCCESS';
export const POST_PERMISE_REJECT = 'POST_PERMISE_REJECT';

//* ACTIONS ------------------------------------------------
export const postPermiseReset = () => ({ type: POST_PERMISE_RESET });
export const postPermiseLoading = () => ({ type: POST_PERMISE_LOADING });
export const postPermiseSuccess = (payload) => ({ type: POST_PERMISE_SUCCESS, payload });
export const postPermiseReject = (payload) => ({ type: POST_PERMISE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postPermiseRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/Profiles/web/AddPermiseToProfile/${data.idProfile}`, options);
};


